<template>
  <div v-if="devMode"> <!-- todo(TECH-407): create component without wrapper - manual virtual dom -->
    <slot name="default"/>
  </div>
</template>

<script>
    /**
     * show child only if dev mode is on
     */
    import {mapState} from "vuex";

    export default {
        name: 'dev-mode',
        props: {},
        data() {
            return {}
        },
        computed: {
            ...mapState({
                devMode: 'devMode'
            }),
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/DevMode.vue